<div class="tabs-container">
  <tabs (tabClicked)="onTabClicked($event)">
    <tab title="Not Submitted">
      <ag-grid-angular class="data-grid " [rowData]="notSubmittedDataCorrectionIndexes" [gridOptions]="notSubmittedGridOptions"  [attr.aria-label]="widgetTitle + ' - Not Submitted'">
      </ag-grid-angular>
    </tab>
    <tab title="Pending">
      <ag-grid-angular class="data-grid " [rowData]="pendingReviewDataCorrectionIndexes" [gridOptions]="pendingReviewGridOptions"  [attr.aria-label]="widgetTitle + ' - Pending'">
      </ag-grid-angular>
    </tab>
    @if (showIncompleteBulkNAD83) {
      <tab title="Incomplete Bulk NAD83 Changes">
        <ag-grid-angular class="data-grid " [rowData]="incompleteBulkNAD83Update$ | async" [gridOptions]="incompleteBulkNAD83GridOptions" [excelStyles]="excelStyles"  [groupDefaultExpanded]="-1" [attr.aria-label]="widgetTitle + ' - Incomplete Bulk NAD83 Changes'"></ag-grid-angular>
      </tab>
    }
    <tab title="Pending Bulk Well Status Changes">
      <ag-grid-angular class="data-grid " [rowData]="pendingBulkStatusChanges$ | async" [gridOptions]="pendingBulkStatusChangeGridOptions" [excelStyles]="excelStyles"  [attr.aria-label]="widgetTitle + ' - Pending Bulk Well Status Changes'"></ag-grid-angular>
    </tab>
    @if (showPendingBulkNAD83) {
      <tab title="Pending Bulk NAD83 Changes">
        <ag-grid-angular class="data-grid " [rowData]="pendingBulkNAD83Update$ | async" [gridOptions]="pendingNAD83GridOptions" [excelStyles]="excelStyles"  [groupDefaultExpanded]="-1" [attr.aria-label]="widgetTitle + ' - Pending Bulk NAD83 Changes'"></ag-grid-angular>
      </tab>
    }
    <tab title="Approved">
      <ag-grid-angular class="data-grid " [rowData]="approvedDataCorrectionIndexes" [gridOptions]="approvedGridOptions"  [attr.aria-label]="widgetTitle + ' - Approved'">
      </ag-grid-angular>
    </tab>
    <tab title="Approved Bulk Well Status Changes">
      <ag-grid-angular class="data-grid " [rowData]="approvedBulkStatusChanges$ | async" [gridOptions]="approvedBulkStatusChangeGridOptions" [excelStyles]="excelStyles"  [groupDefaultExpanded]="-1" [attr.aria-label]="widgetTitle + ' - Approved Bulk Well Status Changes'"></ag-grid-angular>
    </tab>
    @if (showPendingBulkNAD83 || showIncompleteBulkNAD83) {
      <tab title="Approved Bulk NAD83 Changes">
        <ag-grid-angular class="data-grid " [rowData]="approvedBulkNAD83Update$ | async" [gridOptions]="approvedNAD83GridOptions" [excelStyles]="excelStyles"  [groupDefaultExpanded]="-1" [attr.aria-label]="widgetTitle + ' - Approved Bulk NAD83 Changes'"></ag-grid-angular>
      </tab>
    }
    <tab title="Denied">
      <ag-grid-angular class="data-grid " [rowData]="deniedDataCorrectionIndexes" [gridOptions]="deniedGridOptions"  [attr.aria-label]="widgetTitle + ' - Denied'">
      </ag-grid-angular>
    </tab>
    <tab title="Denied Bulk Well Status Changes">
      <ag-grid-angular class="data-grid " [rowData]="rejectedBulkStatusChanges$ | async" [gridOptions]="rejectedBulkStatusChangeGridOptions" [excelStyles]="excelStyles"  [groupDefaultExpanded]="-1" [attr.aria-label]="widgetTitle + ' - Denied Bulk Well Status Changes'"></ag-grid-angular>
    </tab>
    <tab title="Returned">
      <ag-grid-angular class="data-grid " [rowData]="returnedDataCorrectionIndexes" [gridOptions]="returnedGridOptions"  [attr.aria-label]="widgetTitle + ' - Returned'">
      </ag-grid-angular>
    </tab>
  </tabs>
</div>